import React, { Component } from 'react';
import '../../../src/styles/Home.css';
import { Link } from 'react-router-dom';
var Setpad = { paddingLeft: '2%' }
var heightset = { height: '35px' }, heightneedstoset = false

export class LoginLeadingLawPublication extends Component {
    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
    }
    handleSelect(e) {
        window.scrollTo(0, 0);
       
    }

    renderSubscribedList = () => {
        return this.props.subscribedList != null && this.props.subscribedList.map((item, key) => {
            var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
            return (
                <div className="col-lg-4 Subscription" style={{ marginLeft: '3%', maxWidth: '30%' }}>
                    <Link onClick={this.handleSelect} to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}>
                        {item.topic.length > 28 ? heightneedstoset = true : null}
                        <h1 className="HomepageHeading" style={(heightneedstoset == true) ? heightset : null}>
                            <img alt="" src="/../../images/green-arrow.png" /><span style={Setpad}>{item.topic}</span></h1>
                    </Link>
                    <Link onClick={this.handleSelect} to={"/" + (item.productTypeId == "1" ? "Journals" : item.productTypeId == "2" ? "Manuals" : "encyclopedias") + "/" + titlePlus + "/" + item.id}>
                        <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="LeadingLawImg" />
                    </Link>
                    <div>
                        <br></br>
                        <Link onClick={this.handleSelect} to={"/" + (item.productTypeId == "1" ? "Journals" : item.productTypeId == "2" ? "Manuals" : "encyclopedias") + "/" + titlePlus + "/" + item.id}>
                            <h2 className="BookHeading ">{item.title}</h2></Link>
                    </div>
                </div>
            )
        });
    }

    render() {
        return (
            <div id="leading-law-pub">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className="LawHeader">Your subscriptions <span className="BGcolPadding"> <Link to="/Subscription" className="LinkClass">View all</Link></span></h3>
                    </div>
                    {
                        this.renderSubscribedList()
                    }
                </div>
                <div className="row">
                    <div className="White">
                    </div>
                </div >
            </div>
        )
    }
}

export default LoginLeadingLawPublication;


// WEBPACK FOOTER //
// ./src/components/LoginHome/LoginLeadingLawPublication.jsx